/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Logistics_UpdatedInputs */

const en_orders_logistics_updated = /** @type {(inputs: Orders_Logistics_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logistics details updated`)
};

const es_orders_logistics_updated = /** @type {(inputs: Orders_Logistics_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detalles de logistica actualizados`)
};

/**
* | output |
* | --- |
* | "Logistics details updated" |
*
* @param {Orders_Logistics_UpdatedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_logistics_updated = /** @type {((inputs?: Orders_Logistics_UpdatedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Logistics_UpdatedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_logistics_updated(inputs)
	return es_orders_logistics_updated(inputs)
});